<template>
  <div style="overflow: hidden;">
    <!-- <router-link to="/main">
      <img class="trych-logo" src="../../../static/images/logo.png" />
    </router-link> -->
    <el-menu
      v-if="menuListForDev.length>0"
      class="el-menu-topleft"
      mode="horizontal"
      :router="true"
      background-color="rgb(55, 61, 65)"
      text-color="#fff"
      active-text-color="#ffffff"
    >
      <el-menu-item
        v-for="item in menuListForDev.filter(a=>a.parentid==0)"
        :key="item.id"
        @click="changeListMenu(item.id)"
      >
        <el-badge v-if="item.id==6&&noticeList.length>0" :value="noticeList.length" class="item">
          <span>{{item.menuname}}</span>
        </el-badge>
        <span v-else>{{item.menuname}}</span>
      </el-menu-item>
    </el-menu>
    <el-menu
      class="el-menu-topright"
      mode="horizontal"
      :router="true"
      background-color="rgb(55, 61, 65)"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <el-submenu index="2" class="menu-item-loginuser">
        <template slot="title" style="text-align:center;">
         <span>{{userInfo.username}}</span>
        </template>
        <el-menu-item index="2-3" @click="loginout">注销登录</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: ["menuListForDev", "userInfo", "noticeList"],
  /**
   * 组件
   */
  components: {},
  /**
   * 数字
   */
  data() {
    return {
      editDataForm: {},
      dialogTableEditVisible: false,
      saveDataButtonLoading: false,
      departList: [],
      elLeftMenu: {
        isCollapse: false,
        uniqueOpened: true,
        collapseTransition: true,
      },
      selectedItems: [],
      proviceArray: [],
      cityArray: [],
      areaArray: [],
      pageindex: 1,
      userAvatar: [],
      newpassword: "",
      rules: {},
      dialogQywxBindVisible: false,
    };
  },
  /**
   * 监听Vue实例上的数据变动
   */
  watch: {
    menuListForDev(){
    this.$forceUpdate();
    }
  },

  /**
   * 方法、函数
   */
  methods: {
    showBindQywx: function () {
      this.dialogQywxBindVisible = true;
    },
    changeListMenu: function (id) {
      //将时间传递到父级页面
      this.$emit("menuSelectedItemChanged", id);
    },
    loginout: async function () {
      let loginout = await this.http.get("/user/loginout");
      if (loginout) this.$router.push("/login");
    },
    updatePwd: function () {
      this.$router.push("/personnelmatters/persion");
    },
    /**
     * 展示个人信息
     */
    showMySelfUserInfo: function () {
      this.editDataForm.password = "";
      this.newpassword = "";
      this.dialogTableEditVisible = true;
    },
    /**
     * 保存编辑
     */
    saveEditMyPerson: async function () {
      if (this.editDataForm.password == "") {
        this.$message.error("请输入新密码");
        return;
      }
      this.editDataForm.rpassword = this.newpassword;
      if (this.editDataForm.password != this.editDataForm.rpassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }
      this.$refs["editDataForm"].validate(async (valid) => {
        if (valid) {
          this.saveDataButtonLoading = true;
          let res = await this.http.post(
            "/user/saveeditpersonpasword",
            this.editDataForm
          );
          if (res) {
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.dialogTableEditVisible=false;
          } else this.$message.error("保存失败");
          this.saveDataButtonLoading = false;
        } else {
          return false;
        }
      });
    },
  },
  /**
   * 完成挂载
   */
  mounted() {},
  /**
   * 更新完成状态
   */
  updated: function () {},
  /**
   * 完成了 data 数据的初始化
   */
  async created() {
    this.editDataForm = await this.http.get("/user/getloginuserinfo");
    this.editDataForm.password = "";
    this.editDataForm.rpassword = "";
  },
};
</script>
<style>
.el-badge__content.is-fixed {
  top: 10px;
  padding: 0 3px;
  border: none;
  right: 1px;
}
.el-menu--horizontal > .el-submenu .el-submenu__title,
.el-menu--horizontal > .el-menu-item {
  height: 50px !important;
  line-height: 50px !important;
}
.el-menu-topleft {
  float: left;
}
.el-menu-topright {
  float: right;
  margin-right: 20px;
}
.el-menu-item:hover,
.menu-item-loginuser .el-submenu__title:hover {
  background-color: rgb(0, 0, 0) !important;
}
.menu-item-loginuser {
}
.menu-item-loginuser img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 0px 5px 0px 5px;
}
.menu-item-loginuser i {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/menu/topAsideMenu.vue